module.exports = __webpack_public_path__ + "img/apply-icon.770dbe27.svg";